import apiClient from '@/client';

export default {
  get: {
    rewards: (customerSlug, accountSlug) => {
      return apiClient.get(`/public/accounts/${accountSlug}/customers/${customerSlug}/pitcrew/rewards`);
    },
  },
};
